import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCOC2cT9xb4V3Dkw0hQMOR-Z0MPU3hmt0w",
  authDomain: "bane-c2028.firebaseapp.com",
  projectId: "bane-c2028",
  storageBucket: "bane-c2028.firebasestorage.app",
  messagingSenderId: "511248977316",
  appId: "1:511248977316:web:a80019b11ebbc084b18531",
  measurementId: "G-KQY5RTC5BD",
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { db, auth, provider };
